import { OtoIndividualTransferPerson } from '../../lib/types/models/enrollment/oto-individual-enrollments'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

// The accueil-transfert person the provider recorded. The backend refuses it to a parent until
// the visibility window before the departure opens, so only call it once the actions endpoint
// says the parent may view it.
export function getOtoIndividualTransferPerson(enrollmentId: number) {
  return restApiClient
    .url(constructApiUrl(API.enrollments.getOtoIndividualTransferPerson.url, { id: enrollmentId }))
    .get<OtoIndividualTransferPerson | null>()
}
